import { useLayoutEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { view } from '@yola/ws-sdk';

const getMatchesMinWidth = (breakpoint, insets) => {
  const availableWidth = Math.max(0, window.innerWidth - insets.left - insets.right);

  return availableWidth >= parseInt(breakpoint, 10);
};

const useEditorBreakpoint = (breakpoint, { shouldMatchOnMount = false } = {}) => {
  const insets = useSelector(view.selectors.getViewportInsets, shallowEqual);
  const [isMatches, setIsMatches] = useState(() =>
    shouldMatchOnMount ? getMatchesMinWidth(breakpoint, insets) : false
  );

  useLayoutEffect(() => {
    const handleChange = () => setIsMatches(getMatchesMinWidth(breakpoint, insets));

    handleChange();
    window.addEventListener('resize', handleChange);

    return () => {
      window.removeEventListener('resize', handleChange);
    };
  }, [breakpoint, insets]);

  return isMatches;
};

export default useEditorBreakpoint;
